import React, { useState, useEffect, useContext, useImperativeHandle, forwardRef, useMemo } from "react";

//web3 imports
import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import HTTPProvider from "web3";
import { InjectedConnector } from "@web3-react/injected-connector";
import { createWeb3Modal } from "./web3Modal";

//context imports
import ConnectedWalletContext from "./ConnectedWalletContext";
import ContractContext from './ContractContext';

//component imports
import { DefiAppService } from './DefiAppService';

//css imports
import './toggleConnectStyle.css';


//ToggleConnect should use the default defiApp prop passed in from App.js to determine which defiApp to load by default (RocketFi for now).
//getDappProperties: to get the css properties for the selected defiApp.
//getDappContracts: to get the contracts for the selected defiApp.
//it should then use the css properties to style the toggleConnect component.
const ToggleConnect = forwardRef(({ defiApp, onToggle }, ref) => {
    const { activate, deactivate, active, error } = useWeb3React();
    const { connectedAddress, setConnectedAddress } = useContext(ConnectedWalletContext);
    const [web3Modal, setWeb3Modal] = useState(null);
    const injectedConnector = new InjectedConnector();

    const [connectState, setConnectState] = useState("Disconnected");

    const [toggleWidth, setToggleWidth] = useState("230px");
    const [iconWrapperStyle, setIconWrapperStyle] = useState("notchIconWrapper");
    //const [dappProperties, setDappProperties] = useState(DefiAppService.getDappProperties(defiApp)); // dappProperties is an tobject that contains the css properties for the selected defiApp
    const dappProperties = useMemo(() => DefiAppService.getDappProperties(defiApp), [defiApp]);
    const [icon, setIcon] = useState(dappProperties.disconnectIcon);
    const [text, setText] = useState(dappProperties.disconnectedText);
    const [icon2, setIcon2] = useState(null);

    const contractContext = useContext(ContractContext); // contractContext is an object that contains the contracts for the selected defiApp

    const [contractsInitialized, setContractsInitialized] = useState(false);

    useEffect(() => {
        if (connectState === "Disconnected") {
            setIcon(dappProperties.disconnectedIcon);
            setIcon2(null);
            setText(dappProperties.disconnectedText);
        }
        else if (connectState === "Connected") {
            setIcon(dappProperties.connectedIcon2);
            setIcon2(dappProperties.appMenuStandby);
            setText('');
        }

    }, [dappProperties]);


    // useEffect(() => {
    //     setDappProperties(DefiAppService.getDappProperties(defiApp));
    // }, [defiApp]);

    useImperativeHandle(ref, () => ({ toggleConnect }));

    useEffect(() => {
        if (active) {
            setConnectState("Connected");
            setIcon(dappProperties.connectedIcon1);
            setText(dappProperties.connectedText);
        } else if (error) {
            setConnectState("Disconnected");
            setIcon(dappProperties.disconnectedIcon);
            setText(dappProperties.disconnectedText);
            setIcon2(null);
            setToggleWidth("230px");
            setIconWrapperStyle("notchIconWrapper")
        }
    }, [active, error]);

    useEffect(() => {
        const initContracts = async () => {
            if (active && connectedAddress) {
                const web3 = new Web3(window.ethereum);
                const contractsList = DefiAppService.getDappContracts(defiApp);
                const instantiatedContracts = {};
    
                for (const contractName in contractsList) {
                    const contractInfo = contractsList[contractName];
                    const contractInstance = new web3.eth.Contract(contractInfo.abi, contractInfo.address);
    
                    await web3.eth.getCode(contractInfo.address).then((code) => {
                        if (code === "0x") {
                            console.error(`No ${contractName} code found at the specified address:`, contractInfo.address);
                        } else {
                            //console.log(`${contractName} exists at the specified address`);
                        }
                    });

                    //code to validate contract against abi file to ensure it is the correct contract
    
                    instantiatedContracts[contractName] = contractInstance;
                    //console.log(`${contractName} contract initialized:`, contractInstance);
                }
    
                contractContext.setContracts(instantiatedContracts);
                setContractsInitialized(true);
            } else {
                //console.log("Web3 or connected address not available");
            }
        };
        initContracts();
    }, [active, connectedAddress, defiApp]);    


    useEffect(() => {
        if (connectState === "Connected") {
            setTimeout(() => {
                setText('');
                setIcon(dappProperties.connectedIcon2);
                setIcon2(dappProperties.appMenuActive);
                setToggleWidth("100px");
                setIconWrapperStyle("notchIconWrapper connected");
            }, 1500);
        }
    }, [connectState]);


    const connectionStyle = connectState === "Disconnected" ? " disconnect" : connectState === "Connecting" ? " connecting" : "";



    const connectWallet = async () => {
        try {
            const provider = await web3Modal.connect();
            const web3Instance = new Web3(provider);
            await activate(injectedConnector);
            const address = await web3Instance.eth.getAccounts();
            setConnectedAddress(address[0]);
        } catch (err) {
            console.error("Failed to connect to a wallet:", err);
        }
    };

    const disconnectWallet = () => {
        web3Modal.clearCachedProvider();
        deactivate();
        setConnectedAddress(null);
    };

    const toggleConnect = () => {
        if (connectState === "Disconnected") {
            setConnectState("Connecting");
            setIcon(dappProperties.connectingIcon);
            setText(dappProperties.connectingText);
            setTimeout(() => {
                connectWallet();
            }, 1000);
        } else if (connectState === "Connected") {
            setConnectState("Disconnected");
            disconnectWallet();
            setIcon(dappProperties.disconnectedIcon);
            setText(dappProperties.disconnectedText);
            setIcon2(null);
            setToggleWidth("230px");
            setIconWrapperStyle("notchIconWrapper");
        }
    };



    useEffect(() => {
        if (!web3Modal) {
          createWeb3Modal().then((newWeb3Modal) => {
            setWeb3Modal(newWeb3Modal);
          });
        }
      }, [web3Modal]);

    // The toggleConnect function adjusted to use connectWallet and disconnectWallet...

    const handleMouseEnter = () => {
        if (connectState === "Connected") {
            setIcon2(dappProperties.appMenuActive);
        }
    };

    const handleMouseLeave = () => {
        if (connectState === "Connected") {
            setIcon2(dappProperties.appMenuStandby);
        }
    };

    const handleMouseDown = () => {
        if (connectState === "Connected") {
            setIcon2(dappProperties.appMenuPressed);
            onToggle();
        }
    };


    return (
        <div
            onClick={toggleConnect}
            className={`toggle${connectionStyle}`}
            style={{
                width: toggleWidth,
                backgroundImage: `linear-gradient(
                    ${dappProperties[`${connectState.toLowerCase()}ToggleBackground`]},
                    ${dappProperties[`${connectState.toLowerCase()}ToggleBackground`]})`,
                justifyContent: 'center',
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseLeave}
        >
            <div
                style={
                    connectState === "Connected" ?
                        { paddingLeft: '50px', fontSize: '18px', color: dappProperties.connectedTextColor }
                        : {
                            paddingRight: '35px', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: dappProperties[`${connectState.toLowerCase()}TextColor`]
                        }
                }
            >
                <strong>{text}</strong>
            </div>
            <div className="notch" style={{ background: dappProperties[`${connectState.toLowerCase()}NotchColor`] }}>
                <div className={iconWrapperStyle} onClick={e => e.stopPropagation()}>
                    <img src={icon} alt={text} style={{ color: dappProperties[`${connectState.toLowerCase()}IconColor`] }} 
                    onClick={connectState === "Connected" ? null : toggleConnect}
                    />
                    {icon2 && <img src={icon2} alt="icon 2" />}
                </div>
            </div>
            
        </div>
    );
});


export default ToggleConnect;
